export default __webpack_public_path__ + "static/media/avatar_grumpy_cat7.246437a9.mp3";